const BanzaFileDropAreaPresets = {
  BanzaFileDropArea: {
    attrs: {
      variant: "area"
    },
    slots: {
      compactFileIcon: {
        icon: "lets-icons:upload-duotone",
        attrs: {
          color: "primary"
        }
      },
      defaultFileIcon: {
        icon: "lets-icons:upload-duotone",
        attrs: {
          size: "100px",
          color: "primary"
        }
      },
      compactFileText: {
        attrs: {}
      },
      defaultFileText: {
        attrs: {}
      },
      compactFileLink: {
        class: "text-primary font-weight-bold",
        attrs: {
          density: "compact",
          variant: "text",
          size: "default"
        }
      },
      defaultFileLink: {
        class: "text-primary font-weight-bold",
        attrs: {
          density: "compact",
          variant: "text",
          size: "default"
        }
      }
    },
    presets: {
      compactArea: {
        attrs: {
          variant: "compact-area"
        }
      }
    }
  }
};
export {
  BanzaFileDropAreaPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
